import { appConfig } from '@/app-config/appConfig'

import { getCurrentLocale, getRegionFromLocale } from './i18n/locale-utils'

export default function loadGoogleMapsScript(): Promise<void> {
	const locale = getCurrentLocale()
	const region = getRegionFromLocale(locale)

	return new Promise((resolve, reject) => {
		if (window?.google?.maps) {
			resolve()
			return
		}

		const existingScript = document.getElementById('google-maps')
		if (existingScript) {
			existingScript.addEventListener('load', () => resolve())
			existingScript.addEventListener('error', reject)
			return
		}

		const googleMapsScriptElement = document.createElement('script')
		googleMapsScriptElement.id = 'google-maps'
		googleMapsScriptElement.src =
			'https://maps.googleapis.com/maps/api/js?libraries=places&key=' +
			`${appConfig.PLACES_API_KEY}&region=${region}&language=${locale}`
		googleMapsScriptElement.async = true

		googleMapsScriptElement.onload = () => {
			if (window?.google?.maps) {
				resolve()
			} else {
				reject(new Error('google maps still unavailable after load.'))
			}
		}

		googleMapsScriptElement.onerror = () => reject(new Error('Google Maps script failed to load.'))
		document.body.appendChild(googleMapsScriptElement)
	})
}
